import { Box, useMantineTheme } from "@mantine/core";
import styled, { keyframes } from "styled-components";

const bounce = keyframes`
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-5px); }
`;

const BounceBox = styled.div<{ delay: number; color: string }>`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
    animation: ${bounce} 0.8s ease infinite;
    animation-delay: ${({ delay }) => `${delay}s`};
`;

export const TypingIndicator = () => {
    const theme = useMantineTheme();

    return (
        <Box
            style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                height: 24,
                padding: "8px 0",
                margin: "4px 0",
            }}
        >
            {[0, 1, 2].map((i) => (
                <BounceBox key={i} delay={i * 0.15} color={theme.black} />
            ))}
        </Box>
    );
};
